import React from 'react'
import styled from 'styled-components'

const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 180px);
  flex-direction: column;
  gap: 16px;
  padding: 24px;
`

const ErrorTitle = styled.h3`
  color: ${({ theme }) => theme.error || '#d32f2f'};
  margin: 0;
  font-size: 18px;
`

const ErrorMessage = styled.p`
  color: ${({ theme }) => theme.listText || '#666'};
  font-size: 14px;
  text-align: center;
  max-width: 400px;
`

const RetryButton = styled.button`
  padding: 8px 24px;
  border: 1px solid ${({ theme }) => theme.primary || '#4a90d9'};
  background: transparent;
  color: ${({ theme }) => theme.primary || '#4a90d9'};
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background: ${({ theme }) => theme.primary || '#4a90d9'};
    color: white;
  }
`

interface MessagingErrorProps {
  message: string
  onRetry?: () => void
}

export const MessagingError: React.FC<MessagingErrorProps> = ({ message, onRetry }) => (
  <ErrorContainer>
    <ErrorTitle>Messaging Unavailable</ErrorTitle>
    <ErrorMessage>{message}</ErrorMessage>
    {onRetry && <RetryButton onClick={onRetry}>Try Again</RetryButton>}
  </ErrorContainer>
)
